function defaultFilteringFunction(item, filteringText, filteringFields) {
    if (filteringText.length === 0) {
        return true;
    }
    filteringFields = filteringFields || Object.keys(item);
    var lowFilteringText = filteringText.toLowerCase();
    return filteringFields.some(function (key) {
        return String(item[key])
            .toLowerCase()
            .indexOf(lowFilteringText) > -1;
    });
}
export function createFilterPredicate(filtering, filteringText) {
    var _a;
    if (filteringText === void 0) { filteringText = ''; }
    if (!filtering) {
        return null;
    }
    var filteringFunction = (_a = filtering.filteringFunction) !== null && _a !== void 0 ? _a : defaultFilteringFunction;
    return function (item) { return filteringFunction(item, filteringText, filtering.fields); };
}
